export default __webpack_public_path__ + "static/media/Icon_material_edit.22f14106.svg";